"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendedRegions = void 0;
var currencies_1 = require("./currencies");
var regions_1 = require("./regions");
var extendedRegions = {};
exports.extendedRegions = extendedRegions;
var extend = function (region, currency) { return (__assign(__assign({}, region), currency)); };
var _loop_1 = function (brand) {
    extendedRegions[brand] = regions_1.regions[brand].map(function (region) { return (extend(region, currencies_1.currencies[brand][region.currencyCode])); });
};
for (var _i = 0, BRANDS_1 = regions_1.BRANDS; _i < BRANDS_1.length; _i++) {
    var brand = BRANDS_1[_i];
    _loop_1(brand);
}
